import React, { useContext } from 'react'

import { Checkbox, Icon, IconButton } from '@mui/material'
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'

import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import MDInput from 'components/MDInput'
import MDTypography from 'components/MDTypography'
import { DBActionType, FeedbackOutcome } from 'context/materialUI/types'

import { FormContext } from '../../constants'

function CustomerOutcomes(): JSX.Element {
	const formContext = useContext(FormContext)
	const { localForm, setLocalForm, setFormEdited } = formContext

	const handleFormUpdate = (value: FeedbackOutcome[]) => {
		setLocalForm(prev => ({
			...prev,
			outcomes: value,
		}))
		setFormEdited(true)
	}
	const isCustomerComplaint = (item: FeedbackOutcome) =>
		item.memberType.toUpperCase() === 'CUSTOMER' && item.feedbackType === 'COMPLAINT'

	return (
		<Card id="customer">
			<MDBox p={2}>
				<Grid container spacing={3} alignItems="center">
					<Grid item xs={12}>
						<MDBox display={'flex'} flexDirection={'column'} gap={2}>
							<MDTypography variant="h5" fontWeight="medium">
								Customer Outcomes
							</MDTypography>
							<MDTypography variant="button" fontWeight="regular" color="text">
								<i>
									Please detail the different outcomes that are possible for the povider of the the
									feedback e.g. the customer.
								</i>
							</MDTypography>
						</MDBox>
					</Grid>
					<Grid item xs={12}>
						<Grid item xs={12}>
							{localForm?.outcomes?.map((item, index) => {
								if (isCustomerComplaint(item)) {
									return (
										<MDBox
											key={index}
											display={'flex'}
											flexDirection={'row'}
											gap={4}
											alignItems={'center'}
											justifyContent={'space-between'}
											mr={2}
											my={2}
										>
											<MDInput
												variant="outlined"
												value={item.newValue?.find(nv => nv.field === 'name')?.value ?? item.name}
												size="medium"
												label="Outcome"
												sx={{ width: '20rem' }}
												autoComplete="off"
												InputLabelProps={{ shrink: true }}
												onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
													const userInput = e.target.value
													const updatedCustomerOutcomes = localForm?.outcomes.map((entry, i) => {
														if (i !== index) return entry
														const isUpdate = entry.dbAction !== 'CREATE'

														return {
															...entry,
															dbAction: isUpdate
																? ('UPDATE' as DBActionType)
																: ('CREATE' as DBActionType),
															// Keep original outcome untouched if it's an update
															newValue: isUpdate
																? [
																		{
																			field: 'name',
																			value: userInput,
																		},
																	]
																: undefined,
															// Only set outcome directly for new items (CREATE)
															name: isUpdate ? entry.name : userInput,
														}
													})
													handleFormUpdate(updatedCustomerOutcomes)
												}}
											/>

											<MDBox
												display={'flex'}
												flexDirection={'column'}
												alignItems={'center'}
												justifyContent={'center'}
											>
												{index ===
													localForm.outcomes.indexOf(
														localForm?.outcomes.filter(isCustomerComplaint)[0]
													) && (
													<MDTypography variant="body2" fontWeight={'regular'}>
														Has Monetary Value?
													</MDTypography>
												)}
												<Checkbox
													checked={
														item.newValue?.find(nv => nv.field === 'has_monetary_value')?.value ??
														item.has_monetary_value
													}
													onChange={() => {
														const updatedCustomerOutcomes = localForm?.outcomes?.map((entry, i) => {
															if (i !== index) return entry
															const isUpdate = entry.dbAction !== 'CREATE'
															return {
																...entry,
																dbAction: isUpdate
																	? ('UPDATE' as DBActionType)
																	: ('CREATE' as DBActionType),
																// Keep original outcome untouched if it's an update
																newValue: isUpdate
																	? [
																			{
																				field: 'has_monetary_value',
																				value: !(
																					item.newValue?.find(
																						nv => nv.field === 'has_monetary_value'
																					)?.value ?? item.has_monetary_value
																				),
																			},
																		]
																	: undefined,
																// Only set outcome directly for new items (CREATE)
																has_monetary_value: isUpdate
																	? entry.has_monetary_value
																	: !item.has_monetary_value,
															}
														})
														handleFormUpdate(updatedCustomerOutcomes)
													}}
												/>
											</MDBox>

											<IconButton
												size="medium"
												aria-label="delete"
												color="error"
												onClick={() => {
													const index = localForm.outcomes.indexOf(item)
													const temp = [...localForm.outcomes] // Create a shallow copy

													if (item.dbAction === 'CREATE') {
														temp.splice(index, 1) // Remove the item
													} else {
														temp[index] = { ...item, dbAction: 'DELETE', newValue: undefined } //mark it for deletion
													}
													handleFormUpdate(temp)
												}}
											>
												<Icon fontSize="medium">delete_outline</Icon>
											</IconButton>
										</MDBox>
									)
								} else {
									return null
								}
							})}
						</Grid>
					</Grid>
				</Grid>
				<MDButton
					color="primary"
					variant="outlined"
					onClick={() => {
						handleFormUpdate([
							...localForm.outcomes,
							{
								id: -1,
								memberType: 'Customer',
								feedbackType: 'COMPLAINT',
								status: 'ACTIVE',
								name: '',
								has_monetary_value: false,
								dbAction: 'CREATE',
							},
						])
					}}
				>
					+ add new customer outcome
				</MDButton>
			</MDBox>
		</Card>
	)
}

export default CustomerOutcomes
